<template>
    <div id="content" v-if="!loading">
        <div class="inner">
          <p class="paging">
            <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
          </p>
          <p class="buttons">
<!--            <a v-if="$_updateActionAllowed && entity.local_state !== 'PENDING' && entity.local_state !== 'UNUSED'"-->
            <a v-if="$_updateActionAllowed"
               class="btn btn_action btn_grey btn_refresh"
               :title="'Resetovat lokální stav videa' | translate"
               @click.prevent.stop="resetLocalState"
               v-translate>Resetovat lokální stav videa</a>
          </p>
            <h1>{{ entity.name }} <span v-if="entity.season_and_episode_number" @click.stop="goToEpisodes($event, entity.id_show)" style="cursor: pointer;">| {{ entity.season_and_episode_number }}</span></h1>
        </div>
        <div class="responsiveTabs">
            <ul class="tabs">
                <li :class="{'r-tabs-state-active' : this.$route.name === 'vodVideosSettings'}"><a
                    @click.stop="openRoute('vodVideosSettings')" v-translate>Vlastnosti</a></li>
              <li :class="{'r-tabs-state-active' : this.$route.name === 'vodVideosPrices'}"><a
                  @click.stop="openRoute('vodVideosPrices')" v-translate>TVOD ceny</a></li>
                <li :class="{'r-tabs-state-active' : this.$route.name === 'vodVideosPackages'}"><a
                    @click.stop="openRoute('vodVideosPackages')" v-translate>Balíčky videí</a></li>
            </ul>

            <keep-alive>
                <router-view
                    :entity="entity"
                />
            </keep-alive>
          <section class="buttons">
            <p>
              <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam
              </router-link>
            </p>
          </section>
        </div>
    </div>
</template>

<script>
import detailActions from "@/components/mixins/detail-actions"

export default {
    name: "VodVideosDetail",
    mixins: [
        detailActions,
    ],
    data() {
        return {
            entityName: "vodVideo",
            moduleName: "vodVideos",
            loading: true,
        }
    },
    created(VodVideoService) {
        this.entityService = VodVideoService
        this.createdInit()
    },
  methods: {
    goToEpisodes(e, id_show) {
      this.$router.push({name: 'vodEpisodes', params: {id: id_show}})
    },
    resetLocalState(){
      this.entityService.resetLocalState(this.entity.id)
          .then(() => {
            this.getEntity();
          });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/vodVideos/VodVideosDetail.vue